import { useMemo, useReducer } from 'react'
import { initialState, reducer } from '../../state'
import type { Actions, State } from '../../state'
import type { ActivityDetails } from '../../typings'
import { type AsyncDispatch, wrapAsync } from '@sales-center/common'

type UseDataOptions = {
  // SH-1432: allow the context to open in UPDATE mode by seeding `current` (the
  // create->update switch) and the backing `activities`. Omitted => create mode,
  // identical to the previous behaviour (fresh initialState).
  initialCurrent?: number
  initialActivities?: ActivityDetails[]
}

export function useData(options: UseDataOptions = {}) {
  const { initialCurrent, initialActivities } = options

  const [state, dispatch] = useReducer(reducer, undefined, () =>
    initialCurrent !== undefined || initialActivities !== undefined
      ? {
          ...initialState,
          current: initialCurrent ?? initialState.current,
          activities: initialActivities ?? initialState.activities,
        }
      : initialState,
  )

  const asyncDispatch = useMemo(() => wrapAsync(dispatch), [dispatch])

  const value: [State, AsyncDispatch<Actions>] = [state as State, asyncDispatch]

  return {
    value,
  }
}
